import BuyOverlay from './BuyOverlay'
import ReadingSampleChoice from './ReadingSampleChoice'
import ResponsiveMediaSamplePositioning from './ResponsiveMediaSamplePositioning'
import StickyBuyBar from './StickyBuyBar'
import TitleBuyButtons from './TitleBuyButtons'
import VariationDropdown from './VariationDropdown'

export default function init() {
    BuyOverlay()
    VariationDropdown()
    TitleBuyButtons()
    StickyBuyBar()
    ResponsiveMediaSamplePositioning()
    ReadingSampleChoice()
}
